/**
 * ReviewTargetSource represents the different sources where reviews can be pulled in. 
 */

export enum ReviewTargetSource {
    googleMyBusiness = "googleMyBusiness",
    dataShake = "dataShake",
    facebook = 'facebook',
    zembra = 'zembra'
}